import { ApiResponse } from '@smata-models';
import { NotificationFacade, NotificationPageActions } from '@smata-notification';

export function handleApiResponse<T>(
  res: ApiResponse<T>,
  notificationFacade?: NotificationFacade,
): T | null {
  const data = res?.data;

  if (!res?.success) {
    return null;
  }

  if (data && typeof data === 'object' && 'error' in (data as any) && (data as any).error) {
    notificationFacade?.dispatch(
      NotificationPageActions.failure({
        message: (data as any).error,
      }),
    );
    return null;
  }

  return data;
}
